module.exports = {"540222100":"江孜镇","540222200":"纳如乡","540222201":"卡麦乡","540222202":"卡堆乡","540222203":"藏改乡","540222204":"日朗乡","540222205":"达孜乡","540222206":"热索乡","540222207":"重孜乡","540222208":"龙马乡","540222209":"加克西乡","540222210":"紫金乡","540222211":"江热乡","540222212":"年雄乡","540222213":"康卓乡","540222214":"金嘎乡","540222215":"日星乡","540222216":"车仁乡","540222217":"热龙乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540222.json
// module id = 2825
// module chunks = 0